import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { RateDetailContainer } from './components/containers/RateDetailContainer';
import { AddRateItemModal, AddRateItemModalRef } from './components/modals/AddRateItemModal';
import { EditPackagingPricesModal, EditPackagingPricesModalRef } from './components/modals/EditPackagingPricesModal';
import { useRateDetail } from './hooks/useRateDetail';
import './i18n';

export const RateDetail = () => {
  const { id } = useParams<{ id: string }>();
  const addItemModalRef = useRef<AddRateItemModalRef>(null);
  const editPackagingModalRef = useRef<EditPackagingPricesModalRef>(null);

  const rateId = id ? parseInt(id, 10) : null;
  const { rate, refetch } = useRateDetail(rateId);

  return (
    <div className="h-full">
      <RateDetailContainer addItemModalRef={addItemModalRef} editPackagingModalRef={editPackagingModalRef} />

      {rate && rateId && (
        <>
          <AddRateItemModal ref={addItemModalRef} rateId={rateId} existingItems={rate.items} onSuccess={refetch} />
          <EditPackagingPricesModal
            ref={editPackagingModalRef}
            rateId={rateId}
            items={rate.items}
            onSuccess={refetch}
          />
        </>
      )}
    </div>
  );
};
